import NewRequestViewer from "./NewRequestViewer";
import {connect} from "react-redux";
import { getServicesList, downloadServicesList } from "../../../../redux/actions/newService/servicesList.actions";
import { openCommentForm,closeCommentForm } from "../../../../redux/actions/newService/comment.actions";
import { openServiceStatusForm, closeServiceStatusForm } from "../../../../redux/actions/newService/serviceStatus.actions";
import { getCustomers } from "../../../../redux/actions/newService/customers.action";
import { getServices } from "../../../../redux/actions/newService/customerService.action";
import { ReadNotification } from "../../../../redux/actions/notification/getEventNotificationList.action";
import { redirectDemandFilter } from "../../../../redux/actions/userManagement/redirectDemandFilter.action";
import { getModuleNotification } from "../../../../redux/actions/notification/getModuleNotification.action";
import { resetColumnFilters, setColumnFilters } from "../../../../redux/actions/filters/filter.action";

const mapStateToProps = (state) => {
    return {
      statusCount:state.servicesList.count,
      notifications: state.notifications.moduleNotification.data,
      servicesList: state.servicesList.data,
      isLoading: state.servicesList.isLoading,  
      isCommentFormOpen:state.newService.comment.isCommentFormOpen, 
      isServiceStatusFormOpen:state.newService.serviceStatus.isServiceStatusFormOpen,
      myRights:state.myRights.myRights,
      next:state.servicesList.next,  
      customers:state.newService.customers.customers.customers,
      services:state.newService.services.services.services,
      redirectFilter:state?.onboardingRequest?.redirectDemandFilter?.redirectDemandFilter,
      columnFilters: state?.filtersReducer?.columnFilters?.DEMANDS || {},  
      serviceActiveTab:state.newService.service.serviceActiveTab,
      serviceListData:state.servicesList,
    }
  }

const mapDispatchToProps = (dispatch)=>{
    return {
        getServicesList: (filter = '', searchKey = '',next=null,status="",customer="",serviceType="",orderBy="")=>{
            return dispatch(getServicesList(filter, searchKey,next,status,customer,serviceType,orderBy))
        },
        downloadServicesList: (searchKey = '',customer="",serviceType="",orderBy="",isDownalod)=>{
            return dispatch(downloadServicesList(searchKey,customer,serviceType,orderBy,isDownalod))
        },
        openCommentForm : () => {
            return dispatch(openCommentForm())
        },
        closeCommentForm: () => {
            return dispatch(closeCommentForm())
        },
        openServiceStatusForm : () => {
            return dispatch(openServiceStatusForm())
        },
        closeServiceStatusForm: () => {
            return dispatch(closeServiceStatusForm())
        },
        getCustomers: () => {
            return dispatch(getCustomers())
        },
        getServices: ()=>{
            return dispatch(getServices())
        },
        ReadNotification: (payload,id) => {
            return dispatch(ReadNotification(payload,id))
        },
        // setColumnFilters: (tabKey,columnKey, options,pastKey) => {
        //     dispatch(setColumnFilters(tabKey,columnKey, options,pastKey))
        // },
        setColumnFilters: (screen, columnKey, options) =>{
            return dispatch(setColumnFilters(screen, columnKey, options))
        },
        getModuleNotification: () => {
            return dispatch(getModuleNotification())
        },
        resetColumnFilters: (screen) => {
            return dispatch(resetColumnFilters(screen))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRequestViewer);


